import { TextWrapperType } from '../types/wrapper';

const TextWrapper = ({ className, children }: TextWrapperType) => {
    return <div className={className}>{children}</div>;
};

export { TextWrapper };
